import { Controller } from "@hotwired/stimulus"

const CHECK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="w-3.5 h-3.5"><polyline points="20 6 9 17 4 12"/></svg>'

// Connects to data-controller="wizard"
export default class extends Controller {
  static targets = ["step", "stepCircle", "stepLabel"]
  static values = { current: { type: Number, default: 1 } }

  connect() {
    this.showStep(this.currentValue)
  }

  next() {
    const currentStep = this.stepTargets[this.currentValue - 1]
    if (!this.stepIsValid(currentStep)) return

    if (this.currentValue < this.stepTargets.length) {
      this.currentValue += 1
      this.showStep(this.currentValue)
    }
  }

  previous() {
    if (this.currentValue > 1) {
      this.currentValue -= 1
      this.showStep(this.currentValue)
    }
  }

  fileSelected(event) {
    const file = event.target.files[0]
    if (!file) return

    const label = event.target.closest("label").querySelector("[data-wizard-filename]")
    if (label) label.textContent = file.name
  }

  stepIsValid(stepEl) {
    const fields = Array.from(stepEl.querySelectorAll("input, select, textarea"))
    const invalidField = fields.find((field) => !field.checkValidity())
    if (invalidField) {
      invalidField.reportValidity()
      return false
    }
    return true
  }

  showStep(stepNumber) {
    this.stepTargets.forEach((step, index) => {
      step.classList.toggle("hidden", index + 1 !== stepNumber)
    })
    this.updateIndicator(stepNumber)
    this.element.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  updateIndicator(stepNumber) {
    this.stepCircleTargets.forEach((circle, index) => {
      const step = index + 1
      const label = this.stepLabelTargets[index]

      circle.classList.remove("bg-brand-red", "bg-success", "bg-divider", "text-white", "text-text-muted")
      label.classList.remove("text-text-primary", "font-bold", "text-text-muted", "font-normal")

      if (step < stepNumber) {
        circle.classList.add("bg-success", "text-white")
        circle.innerHTML = CHECK_ICON
        label.classList.add("text-text-muted", "font-normal")
      } else if (step === stepNumber) {
        circle.classList.add("bg-brand-red", "text-white")
        circle.textContent = step
        label.classList.add("text-text-primary", "font-bold")
      } else {
        circle.classList.add("bg-divider", "text-text-muted")
        circle.textContent = step
        label.classList.add("text-text-muted", "font-normal")
      }
    })
  }
}
